import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

/**
 * Endpoint for the site root so Azure's AlwaysOn feature can ping the webapi's without causing exceptions.
 *
 * @returns any Success
 */
export function siteRoot(requestConfig: ApiRequestConfig = {}): Promise<any> {
  return request(
    {
      method: 'GET',
      path: `/`,
    },
    requestConfig,
  );
}
